import React from 'react';
var PrimitiveContext = /*#__PURE__*/React.createContext({});
export default PrimitiveContext;
/**
 * Defines a context to supply the environment-specific Primitive component.
 */

var PrimitiveProvider = function PrimitiveProvider(_ref) {
  var Primitive = _ref.Primitive,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(PrimitiveContext.Provider, {
    value: Primitive
  }, children);
};

export { PrimitiveProvider };